/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import USER_MANAGE from '../BaseComponent/USERMANAGE'

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})

class EditInfoUsers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      personInfo: {},
      selectedDate: '',
      Cities: []
    }
  }

  componentDidMount() {
    let {personId} = this.props.match.params
    http
      .get(`${USER_MANAGE.USER_MANAGE_GET_USER}?personId=${personId}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            personInfo: response.data.object,
            selectedDate: response.data.object.birthday
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    http
      .get(`base/report/city?export=true`, {})
      .then((response) => {
        let city = response.data.object.result

        if (response.data.error == null) {
          this.setState({
            Cities: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  submit(e) {
    e.preventDefault()
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }
  epochFrom = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }
  editInfo() {
    var {personId} = this.props.match.params
    var firstname = document.getElementById('firstname').value
    var lastname = document.getElementById('lastname').value
    var mobile = document.getElementById('mobile').value
    var internalNumber = document.getElementById('internalNumber').value
    var email = document.getElementById('email').value
    var phone = document.getElementById('phone').value
    var nationalId = document.getElementById('nationalId').value
    var userCode = document.getElementById('userCode').value
    var father = document.getElementById('father').value
    var birthday = document.getElementById('birthday').value
    var cityId = document.getElementById('cityId').value
    var zipCode = document.getElementById('zipCode').value
    var address = document.getElementById('address').value

    var firstnameError = false
    var lastnameError = false
    var birthDayError = false

    var mobileError = false
    var emailError = false
    var formError = false

    if (firstname == '') {
      firstnameError = true
      formError = true
      message.error('نام را وارد کنید')
    } else {
      if (!firstnameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (
      birthday !== '' &&
      !birthday.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/g
      )
    ) {
      birthDayError = true
      formError = true
      message.error('فرمت تولد صحیح وارد شود')
    } else {
      if (!birthDayError) {
      }
    }

    if (lastname == '') {
      lastnameError = true
      formError = true
      message.error('نام خانوادگی را وارد کنید')
    } else {
      if (!lastnameError) {
        this.setState({error: ''})
      }
    }

    if (mobile == '') {
      mobileError = true
      formError = true
      message.error('موبایل را وارد کنید')
    } else if (!mobile.match(/^09\d{9}$/g)) {
      mobileError = true
      formError = true
      message.error('موبایل را صحیح وارد کنید.مثال : 09124444444')
    } else {
      if (!mobileError) {
        this.setState({error: ''})
      }
    }

    if (
      !(email == '') &&
      !email.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/g
      )
    ) {
      emailError = true
      formError = true
      message.error('ایمیل را صحیح وارد کنید')
    } else {
      if (!emailError) {
        this.setState({error: ''})
      }
    }

    if (!formError) {
      let data = {
        personId: personId,
        firstname: firstname,
        lastname: lastname,
        mobile: mobile,
        internalNumber,
        email: email === '' ? undefined : email,
        phone: phone === '' ? undefined : phone,
        nationalId: nationalId === '' ? undefined : nationalId,
        userCode: userCode === '' ? null : userCode,
        father: father === '' ? undefined : father,
        birthday:
          birthday === '' ? undefined : this.convertDigit(jMoment(birthday, 'jYYYY/jMM/jDD').format('YYYY/MM/DD')),
        cityId: cityId === '' ? undefined : cityId,
        zipCode: zipCode === '' ? undefined : zipCode,
        address: address === '' ? undefined : address
      }

      // alert(JSON.stringify(data))

      http
        .post(`${USER_MANAGE.USER_MANAGE_EDIT_INFO}`, data, {})
        .then((response) => {
          if (response.data.error == null) {
            message.success('ویرایش کاربر با موفقیت انجام شد')
            window.location.assign('/Operators')
          } else {
            // message.error(response.data.description)
          }
          // alert(JSON.stringify(response.data))
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  render() {
    let {personInfo, selectedDate} = this.state
    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/Operators'}>کاربران</Link>
            </li>
            <li>ویرایش کاربر</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ویرایش کاربر</p>
            </div>
            <div className="formComponent">
              <label>نام (الزامی)</label>
              <input type="text" defaultValue={personInfo.firstname} id="firstname" className="form-control" />

              <label>نام خانوادگی (الزامی)</label>
              <input type="text" defaultValue={personInfo.lastname} id="lastname" className="form-control" />

              <label>موبایل (الزامی)</label>
              <input type="text" defaultValue={personInfo.mobile} id="mobile" className="form-control" />

              <label>شماره داخلی </label>
              <input
                type="text"
                defaultValue={personInfo.internalNumber}
                id="internalNumber"
                className="form-control"
              />

              <label>ایمیل</label>
              <input type="email" defaultValue={personInfo.email} id="email" className="form-control" />

              <label>تلفن</label>
              <input type="text" id="phone" defaultValue={personInfo.phone} className="form-control" />

              <label>کد ملی</label>
              <input type="text" id="nationalId" defaultValue={personInfo.nationalId} className="form-control" />

              <label>کد پرسنلی</label>
              <input type="text" id="userCode" defaultValue={personInfo.userCode} className="form-control" />

              <label>نام پدر</label>
              <input type="text" id="father" defaultValue={personInfo.father} className="form-control" />

              <label>تاریخ تولد</label>
              <input
                type="text"
                id="birthday"
                defaultValue={personInfo.birthday == null ? '' : jMoment(personInfo.birthday).format('jYYYY/jMM/jDD')}
                className="form-control"
              />

              <label>شهر </label>
              <select id="cityId" className="form-control" name="cityId">
                <option value="">------</option>
                {this.state.Cities.map((city, index) => (
                  <option value={city.cityId} selected={personInfo.city == city.cityName ? true : false}>
                    {city.cityName}
                  </option>
                ))}
              </select>

              <label>کد پستی</label>
              <input type="text" id="zipCode" defaultValue={personInfo.zipCode} className="form-control" />

              <label>آدرس</label>
              <input type="text" id="address" defaultValue={personInfo.address} className="form-control" />

              <button className="btn btn-primary btn-block" onClick={this.editInfo.bind(this)}>
                ویرایش مشخصات
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default EditInfoUsers
